// extracted by mini-css-extract-plugin
export default {"root":"page404_root__AWO-o"};